import { render, staticRenderFns } from "./JSort.vue?vue&type=template&id=4da69e50&scoped=true&"
import script from "./JSort.vue?vue&type=script&lang=js&"
export * from "./JSort.vue?vue&type=script&lang=js&"
import style0 from "./JSort.vue?vue&type=style&index=0&id=4da69e50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da69e50",
  null
  
)

export default component.exports